/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/secureConnectionMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a SecureConnection. */
export class SecureConnection {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a SecureConnection.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Deprecated endpoint due to VPN feature deprication. Calls Secure Connection Service to get the
   * bandwidth usage data for the current user.
   * @summary Retrieves the bandwidth usage information for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.SecureConnectionGetBandwidthUsageResponse>
   */
  getBandwidthUsage(options?: coreHttp.RequestOptionsBase): Promise<Models.SecureConnectionGetBandwidthUsageResponse>;
  /**
   * @param callback The callback
   */
  getBandwidthUsage(callback: coreHttp.ServiceCallback<Models.BandwidthUsage>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getBandwidthUsage(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.BandwidthUsage>): void;
  getBandwidthUsage(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.BandwidthUsage>, callback?: coreHttp.ServiceCallback<Models.BandwidthUsage>): Promise<Models.SecureConnectionGetBandwidthUsageResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getBandwidthUsageOperationSpec,
      callback) as Promise<Models.SecureConnectionGetBandwidthUsageResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getBandwidthUsageOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/SecureConnection/bandwidth/usage",
  responses: {
    200: {
      bodyMapper: Mappers.BandwidthUsage
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
